<style scoped>

  @media only screen and (min-width: 991px) {
    .inline.fields {
      margin-top: -15px !important;
    }
  }

  .drag-tip-label {
    float: right; 
    margin-top: 2px;
  }

</style>

<template>

  <div>

    <div class="ui large breadcrumb">      
      <a class="clickable" @click="goBack()">
        <i class="reply icon m-r-5"></i> Voltar
      </a>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>{{ isCreating ? creatingTitle : updatingTitle }}</strong>
      </div>
    </div>

    <bookmark-button v-if="isCreating" :label="creatingTitle" />

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-show="!loading" class="animated fadeIn">      

      <div class="ui segment">
        <h4 class="ui dividing header">Dados do Recado</h4>
        <div class="ui form">  
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Tipo <span class="red text">*</span></label> 
            </div> 
          </div>
          <div class="inline fields">
            <div class="field">
              <div class="ui radio checkbox note-form-checkbox">
                <input type="radio" class="hidden" value="urgent" v-model="note.severity">
                <label><i class="exclamation circle red icon"></i> Urgente</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox note-form-checkbox m-l-10">
                <input type="radio" class="hidden" value="warning" v-model="note.severity">
                <label><i class="exclamation triangle orange icon"></i> Alerta</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox note-form-checkbox m-l-10">
                <input type="radio" class="hidden" value="info" v-model="note.severity">
                <label><i class="info circle blue icon"></i> Informativo</label>
              </div>
            </div>
          </div>        
          <div class="fields">            
            <div class="seven wide field">
              <label class="form-label">Assunto <span class="red text">*</span></label>
              <input v-model="note.subject">
            </div>                                              
          </div>   
          <div class="fields">            
            <div class="sixteen wide field">
              <label class="form-label">Mensagem</label>
              <textarea rows="10" v-model="note.message"></textarea>
            </div>     
          </div>      
        </div>
      </div>  

      <div class="ui segment" :class="{ loading: loadingImage, secondary: dragging }" draggable="true" 
        @dragover="onDragOver($event)" @dragleave="onDragLeave($event)" @drop="onDrop($event)">

        <h4 class="ui dividing header">Imagem</h4>
        
        <div class="ui form">
          <div class="fields">
            <div class="sixteen wide field">
              <input v-show="false" type="file" id="note-image-file-input" ref="image" @change="onImageChange()">
              <button class="ui mini basic button" @click="onSelectImage()">
                <i class="upload blue icon"></i> Selecionar imagem
              </button>
              <button v-if="image" class="ui mini basic button m-l-10" @click="onRemoveImage()">
                <i class="times red icon"></i> Remover imagem
              </button>  
              <div :class="dragTip.labelClass">            
                <i :class="dragTip.icon"></i> {{ dragTip.text }}
              </div>
            </div>
          </div>
        </div>

        <div v-show="image" class="ui basic centered segment animated fadeIn">
          <div class="ui large centered rounded image">            
            <img id="note-image-preview" src="#" />          
          </div>
        </div>

        <p v-if="!image" class="grey text animated fadeIn m-t-30 m-b-30">
          <i class="info circle icon"></i> Nenhuma imagem selecionada
        </p>

      </div> 

      <div class="ui segment form-segment">

        <h4 class="ui dividing header">Usuários</h4>
        
        <button class="ui mini basic button" @click="$refs.userPicker.show()">
          <i class="plus blue icon"></i> Adicionar usuários
        </button>

        <button v-if="hasUsers" class="ui mini basic button m-l-10" @click="note.users = []">
          <i class="times red icon"></i> Remover todos
        </button>           
        
        <table v-if="hasUsers" class="ui celled selectable tablet stackable table animated fadeIn">
          <thead v-if="$isDesktop">
            <tr>
              <th>Nome</th>
              <th>Perfil</th>
              <th>Visualização</th>
              <th></th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(user, index) in note.users">
              <td>
                <strong class="mobile-only">Nome: </strong> {{ user.name + ' ' + user.lastName }}                  
              </td>
              <td>
                <strong class="mobile-only">Perfil: </strong> 
                <user-group-icon :group="user.group" />
                {{ user.groupName }}                  
              </td>
              <td>
                <strong class="mobile-only">Visualização: </strong>
                <i v-if="user.viewedAt" class="check double blue icon"></i>  
                {{ renderViewedAt(user) }}                  
              </td>
              <td style="width: 50px;">
                <button class="ui small icon button" @click="onRemoveUser(index)">
                  <i class="times icon"></i>
                </button>
              </td>
            </tr>                
          </tbody>
        </table>

        <p v-else class="grey text m-t-30 m-b-30 animated fadeIn">
          <i class="info circle icon"></i> Nenhum usuário adicionado
        </p>

      </div>

      <div class="m-t-20">
        <button class="ui basic button" @click="goBack()">
          <i class="reply icon"></i> Cancelar
        </button>
        <button v-if="isUpdating" class="ui basic red button m-l-10" 
          :class="{ loading: removing }" @click="$refs.confirmRemovalModal.show()">
          <i class="trash icon"></i> Excluir
        </button> 
        <button class="ui right floated blue button" :class="{ loading: saving }" @click="onConfirm()">
          <i class="check icon"></i> {{ isCreating ? 'Confirmar' : 'Atualizar' }}
        </button>         
      </div>

      <user-picker-multiple ref="userPicker" @onPickUsers="onPickUsers" />

      <yes-no-modal ref="confirmRemovalModal" danger="true"
        :message="`Confirma exclusão do recado ${note.subject} ?`"  @onYes="onConfirmRemoval()" />

    </div>
  
  </div>  
  
</template>

<script>
  
  import _ from "underscore"
  import axios from "axios"
  import moment from "moment"
  import NoteService from "@/services/note-service"  
  import clearSpecialChars from "@/utils/clear-special-chars"
  import { UserGroupIcon, UserPickerMultiple } from "@/components"
  import { formPage, onlySimavet } from "@/mixins"

  export default {
    
    name: "NoteForm",

    mixins: [formPage, onlySimavet],

    data() {
      return {
        creatingTitle: "Novo Recado",
        updatingTitle: "Alterar Recado",
        service: new NoteService(),
        note: { users: [] },     
        image: null,   
        dragging: false,
        loadingImage: false,        
      }
    },    

    components: {
      UserPickerMultiple,
      UserGroupIcon,
    },    

    created() {
      
      this.initFormPage()

      if (this.isUpdating)
        this.loadNote()      
    },  
    
    mounted() {
      $(".note-form-checkbox").checkbox()
    },

    computed: {

      hasUsers() {
        return (this.note.users.length > 0)
      },

      dragTip() {

        if (this.readOnly)
          return {}

        let labelClass = "ui small label drag-tip-label"
        let icon = "lightbulb outline purple icon"
        let text = "Você também pode arrastar o arquivo aqui"

       if (this.dragging) {
          
          labelClass += " green"
          icon = "info circle icon"
          text = "Solte para definir a imagem"
        }  

        return { labelClass, icon, text }
      },
    },

    methods: {

      async loadNote() {

        this.loading = true

        try {

          let note = await this.service.findById(this.$route.params.id)
          let users = []

          note.users.forEach((user) => {
            users.push({
              ...user.user,
              viewedAt: user.viewedAt,              
            })
          })

          note.users = users.slice()          

          if (note.hasImage) {
            this.image = await this.service.getNoteImage(note.id)
            $("#note-image-preview").attr("src", this.image.url)
          }  

          this.note = note

        } catch (error) {          

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      onSelectImage() {
        $("#note-image-file-input").click()
      },

      onDragOver($event) {
        
        $event.preventDefault()
        $event.stopPropagation()

        this.dragging = true
      },

      onDragLeave($event) {

        $event.preventDefault()
        $event.stopPropagation()

        this.dragging = false  
      },

      async onDrop($event) {
        
        $event.preventDefault()
        $event.stopPropagation()

        const df = $event.dataTransfer

        if (!df) {
          this.dragging = false
          return
        }

        let image = null
        let files = []
        let uploadedFiles = 0

        if (df.items) {          
          for (let index = 0; index < df.items.length; index++) {
            if (df.items[index].kind === "file" && this.isFile(df.items[index]))
              files.push(df.items[index].getAsFile())
          }
        } else if (df.files) {
          for (let index = 0; index < df.files.length; index++) {
            files.push(df.files[index])
          }
        }          

        for (let index = 0; index < files.length; index++) {

          if (uploadedFiles == 1)
            continue

          image = files[index]
          
          uploadedFiles++
        }                  

        this.dragging = false        

        if (uploadedFiles > 0) {

          await this.removeImage()

          this.image = image 

          this.onImageChange()  
        }            
      },

      isFile(item) {

        let isFile = true

        if (typeof item.webkitGetAsEntry == "function")
          isFile = item.webkitGetAsEntry().isFile

        return isFile
      },

      onImageChange() {  
        
        if (!this.image)
          this.image = this.$refs.image.files[0]

        if (!this.image)
          return          

        const reader = new FileReader()
        
        reader.onload = (event) => {
          $("#note-image-preview").attr("src", event.target.result)
        }

        reader.readAsDataURL(this.image)

        if (this.isUpdating)
          this.uploadImage()
      },

      onPickUsers(users) {              
        users.forEach(this.addUser)
        this.sortUsers()
      },

      addUser(user) {              

        let exists = false

        this.note.users.forEach((el) => {
          if (user.id == el.id)
            exists = true
        })

        if (!exists)
          this.note.users.push(this.$cloneObject(user))
      },

      onRemoveUser(index) {
        this.note.users.splice(index, 1)
        this.sortUsers()
      },

      sortUsers() {
        
        let sortedUsers = []

        for (let user of this.note.users) {
          user.fullName = user.name.trim().toLowerCase() + user.lastName.trim().toLowerCase()
          sortedUsers.push(user)
        }

        sortedUsers = _.sortBy(sortedUsers, "fullName")

        this.note.users = sortedUsers.slice()
      },

      renderViewedAt(user) {

        if (!user.viewedAt)
          return ""

        return moment(user.viewedAt).format("DD/MM/YYYY [às] HH:mm")
      },

      async onConfirm() {

        if (!this.validData())
          return

        this.saving = true

        try {

          this.note.userId = this.$store.state.auth.user.id
          this.note.hasImage = !!this.image

          if (this.isCreating) {
            
            const newNote = await this.service.create(this.note)
            
            this.note.id = newNote.id

            await this.uploadImage()

          } else {

            await this.service.update(this.note)
          }          

          this.$reloadDataTables(["notes"])

          this.$msg.success(this.isCreating ? "Recado criado com sucesso" : "Recado atualizado com sucesso")

          this.goBack()

        } catch (error) {

          this.saving = false

          this.$errorHandler(error)
        }
      },

      validData() {

        let isOk = true
        let message = ""

        if (!this.note.severity) {
          message = "Informe o tipo do recado"
        } else if (!this.note.subject) {
          message = "Informe o assunto do recado"
        } else if (!this.hasUsers) {
          message = "Nenhum usuário adicionado"
        } else if (!this.image && !this.note.message) {
          message = "Informe a mensagem ou uma imagem"
        }

        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },

      async onConfirmRemoval() {
        
        this.removing = true

        try {
          
          await this.removeImage()
          await this.service.remove(this.note)          

          this.$reloadDataTables(["notes"])

          this.$msg.success("Recado excluído com sucesso")

          this.goBack()

        } catch (error) {

          this.removing = false

          this.$errorHandler(error)
        }
      },

      async uploadImage() {   
        
        if (!this.image)
          return

        this.loadingImage = true

        try {

          const url = `${process.env.VUE_APP_API_URL}/notes/${this.note.id}/image`

          const headers = {
            "Content-Type": "multipart/form-data",
            "auth-token": await this.$store.state.auth.fbUser.getIdToken(true),
          }

          let formData = new FormData()          
          let fileName = this.clearFileName(this.image.name)
          
          formData.append("file", this.image, fileName)

          await axios.post(url, formData, { headers })                            
          
        } catch (error) {          

          this.$errorHandler(error)

        } finally {

          this.loadingImage = false
        }
      },

      clearFileName(name) {

        let cleanName = clearSpecialChars(name)

        return cleanName.replace(/[^a-zA-Z0-9-_\.]/g, '')
      },

      onRemoveImage() {

        if (this.isCreating) {
          this.image = null
        } else {
          this.removeImage()
        }
      },

      async removeImage() {

        if (!this.image)
          return

        this.loadingImage = true  

        try {

          await this.service.removeNoteImage(this.note.id, this.image) 

          this.image = null          
          this.note.hasImage = false

          await this.service.update(this.note)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loadingImage = false
        }
      },
    },
  }

</script>